var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-day t-day_small",class:{'t-day_active': _vm.active, 't-day_select': _vm.select},on:{"click":function($event){$event.preventDefault();return _vm.SetDay()}}},[_c('p',{staticClass:"t-day__date"},[_vm._v(_vm._s(_vm.day))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e7e232","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_components/Calendar_small/Day.vue
// module id = 351
// module chunks = 0